import * as React from "react";
import * as request from "superagent";
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';

// import { Definition } from "~common/lib/types";
import { APIError } from "~common/lib/types";
import URLManager from "~common/lib/url-manager";
import { Theme } from "@mui/styles";
import LoadingView from "~common/components/loading-view";
import DefinitionFieldHider from "./definition-field-hider";

import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography
} from "@mui/material";

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  modalContent: {
    minHeight: 300,
    width: 570,
  },
  modal: {
    minHeight: 300,
    minWidth: 600,
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  resultsForm?: any;
  handleCancel?: Function;
  handleComplete?: Function;
  completeButtonText?: string;
  hiddenFields?: Array<any>;
  // Grid Spacing is the spacing for the grid that will be honored in the form.  Will default to 8
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
}

type State = {
  status: "loading" | "ready" | "error";
  template?: any;
  error?: any;
  hiddenFields?: Array<any>;
};

class DataExtractDialog extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "loading",
      hiddenFields: [],
    };
  }

  UNSAFE_componentWillReceiveProps(newProps: any) {
    this.setState({ hiddenFields: newProps.hiddenFields});
  }

 componentDidMount() {
    this.setState({ hiddenFields: this.props.hiddenFields});
  }

  handleCancel = () => {
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  };

  handleComplete = () => {
    const {hiddenFields} = this.state;
    const {resultsForm} = this.props;
    if (this.props.handleComplete) {
      this.props.handleComplete(hiddenFields);
    }
  };

  handleRestoreDefault = () => {
    const {hiddenFields} = this.state;
    const {resultsForm} = this.props;
    if (this.props.handleComplete) {
      this.props.handleComplete([]);
    }
  };

  handleSelectionChange = (srcDef: any, srcDefPath: string | undefined, item: any, checked: boolean) => {
    let {hiddenFields} = this.state;
    let dimIdx = -1
    // So this means a new checkbox has been selected.
    if (item && item.key) {
    
      var newHiddenFields = []
      for (let hiddenPath of hiddenFields) {
        if (checked && hiddenPath == item.key) {
          continue
        } else {
          newHiddenFields.push(hiddenPath)
        }
      }
      if (!checked) {
        newHiddenFields.push(item.key)
      }

      this.setState({hiddenFields: newHiddenFields})
    }
    


  }

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {resultsForm} = this.props;
    const { status, hiddenFields } = this.state;
    let selector:any = <DefinitionFieldHider suppressTitle={true} showAllFields={true} definition={resultsForm} onSelectionChange={this.handleSelectionChange} hiddenFields={hiddenFields}  />;

    return (
      <Dialog
      className={classes.modal}
      open={true}
      onClose={this.handleCancel}
    >
      <DialogTitle>Customize Visible Results Fields</DialogTitle>
      <DialogContent
        style={{ minHeight: 300, minWidth: 300 }}
        className={classes.modalContent}
      >
          <Typography variant="subtitle1" gutterBottom>
            Please select the fields that you would like to show in the results. 
          </Typography>
          <div>{selector}</div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={this.handleCancel}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          autoFocus={true}
          onClick={this.handleRestoreDefault}
          variant="contained"
          color="secondary"
        >
          Restore Default
        </Button>
        <Button
          autoFocus={true}
          onClick={this.handleComplete}
          variant="contained"
          color="primary"
        >
          Apply 
        </Button>
      </DialogActions>
    </Dialog>
    );

  }
}

export default withStyles(styles)(DataExtractDialog);
